import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=0ce49b4a&scoped=true"
import script from "./Diagram.vue?vue&type=script&lang=ts"
export * from "./Diagram.vue?vue&type=script&lang=ts"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=0ce49b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce49b4a",
  null
  
)

export default component.exports